import request from '../../../../utils/request';
import {paramSecret} from "../../../../utils/commonSecret";

// 绑定手机
export async function bindPhone(params) {
    return request('/api/v1/business-server/member/kefu/bindPhone',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 绑定手机
export async function unBindPhone(params) {
    return request('/api/v1/business-server/member/kefu/unBindPhone',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 修改密码
export async function modifyPassWord(params) {
    return request('/api/v1/business-server/member/kefu/modifyPassWord',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 查询绑定信息
export async function bindPhoneQuery(params) {
    return request('/api/v1/business-server/member/kefu/bindPhoneQuery',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 账号申诉
export async function accountAppeal(params) {
    return request('/api/v1/business-server/member/accountAppeal',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 账号注销
export async function accountCancel(params) {
    return request('/api/v1/business-server/member/accountCancel',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}


// 未登录状态注销撤回
export async function accountCancelRepealWithGameId(params) {
    return request('/api/v1/business-server/member/accountCancelRepealWithGameId', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 查询实名认证信息
export async function verifyCardInfo(params) {
    return request('/api/v1/business-server/member/kefu/verifyCardInfo',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 查询记录 查询类型：1=充值记录；2=登录记录；3=比赛记录；4=招财猫(下掉)；5=奖券记录
export async function logQuery(params) {
    return request('/api/v1/business-server/member/kefu/logQuery',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 查询申诉进度
export async function accountAppealPlanQueryByToken(params) {
    return request('/api/v1/business-server/member/accountAppealPlanQueryByToken',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 人脸识别认证
export async function unBindPhoneFaceVerify(params,isH5=false) {
    return request('/api/v1/business-server/member/unBindPhoneFaceVerifyCertify',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params,isH5)),
    })
}

// 人脸识别认证状态查询
export async function unBindPhoneFaceVerifyQuery(params,isH5=false) {
    return request('/api/v1/business-server/member/unBindPhoneFaceVerifyQuery',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params,isH5)),
    })
}

// 人脸识别认证状态查询
export async function getTokenParam(params) {
    return request('/api/v1/business-server/api/getTokenParam',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 发送短信验证码 token版
export async function sendSmsCodeByToken(params) {
    return request('/api/v1/business-server/member/sendsmscodesliderbytoken',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 获取用户信息
export async function getUserInfo(params) {
    return request('/api/v1/user/userinfo',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 帐号挂失/解除 protectDenyUser
export async function ProtectDenyUserByToken(params) {
    return request('/api/v1/business-server/member/protectDenyUserByToken', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 获取密保信息
export async function ProtectUser(params) {
    return request('/api/v1/business-server/member/protectUser', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 换绑手机
export async function changePhone(params) {
    return request('/api/v1/business-server/member/kefu/changePhone',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

export async function submitStolen(params) {
    return request('/api/v1/business-server/member/stolen',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 找回登录密码
export async function FindPwdOps(params) {
    return request('/api/v1/business-server/member/findPwd', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 获取Pc游戏列表
export async function getPcGameList(params) {
    return request('/api/v1/business-server/member/gameList',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 获取手机游戏列表
export async function getPhoneGameList(params) {
    return request('/api/v1/business-server/member/phoneGameList',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 提交道具异常信息
export async function submitPropEx(params) {
    return request('/api/v1/business-server/member/propEx',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

export async function submitLoginEx(params) {
    return request('/api/v1/business-server/member/loginEx',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 投诉建议
export async function AccountSuggest(params) {
    return request('/api/v1/business-server/member/suggest',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 不良信息投诉建议
export async function badSuggest(params) {
    return request('/api/v1/business-server/member/badsuggest',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 停权名单账号查询
export async function AccountDenyLog(params) {
    return request('/api/v1/business-server/member/accountDenyLogQuery',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 账号密码查询用户信息
export async function FindPwdUnBindQuery(params) {
    return request('/api/v1/business-server/member/findBoxPwdUnBindQuery', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 解绑本机操作
export async function UnBindMacOperator(params) {
    return request('/api/v1/business-server/member/unBindMac', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 根据场景发送短信验证码带滑块验证码验证
export async function SendSmsCodeSlider(params, isH5 = false) {
    return request('/api/v1/business-server/member/sendsmscodeslider', {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params, isH5)),
    })
}
